/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';

interface Props extends React.PropsWithChildren {
  gridRef: React.RefObject<AgGridReact<any>>;
  topSectionCtnClassName?: string;
  gridSideToolPanelCtnClassName?: string;
  filterCheckBoxClassName?: string;
}

const AGGridHoc = ({ children, ...props }: Props) => {
  const { gridSideToolPanelCtnClassName, topSectionCtnClassName, gridRef, filterCheckBoxClassName } = props;

  const handleGlobalClick = useCallback((event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const filterCheckBox = target.closest(`.${filterCheckBoxClassName || 'ag-filter-virtual-list-item'}`);
    const toolPanel = target.closest(`.${gridSideToolPanelCtnClassName || 'ag-tool-panel-wrapper'}`);
    const topSection = target.closest(`.${topSectionCtnClassName || 'top-section'}`);
    if (
      topSection === null &&
      filterCheckBox === null &&
      toolPanel === null &&
      gridRef.current?.api.isToolPanelShowing()
    ) {
      gridRef.current?.api.closeToolPanel();
    }
  }, []);

  useEffect(() => {
    window.addEventListener('click', handleGlobalClick);

    return () => {
      window.removeEventListener('click', handleGlobalClick);
    };
  }, []);

  return <>{children}</>;
};

export default AGGridHoc;
